/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);

/* Run function after window resize */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();



      $.fn.hoverIntent = function(handlerIn, handlerOut, selector) {
        var cfg = {
          interval: 100,
          sensitivity: 6,
          timeout: 400
        };
        if (typeof handlerIn === "object") {
          cfg = $.extend(cfg, handlerIn)
        } else {
          if ($.isFunction(handlerOut)) {
            cfg = $.extend(cfg, {
              over: handlerIn,
              out: handlerOut,
              selector: selector
            })
          } else {
            cfg = $.extend(cfg, {
              over: handlerIn,
              out: handlerIn,
              selector: handlerOut
            })
          }
        }
        var cX, cY, pX, pY;
        var track = function(ev) {
          cX = ev.pageX;
          cY = ev.pageY
        };
        var compare = function(ev, ob) {
          ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
          if (Math.sqrt((pX - cX) * (pX - cX) + (pY - cY) * (pY - cY)) < cfg.sensitivity) {
            $(ob).off("mousemove.hoverIntent", track);
            ob.hoverIntent_s = true;
            return cfg.over.apply(ob, [ev])
          } else {
            pX = cX;
            pY = cY;
            ob.hoverIntent_t = setTimeout(function() {
              compare(ev, ob)
            }, cfg.interval)
          }
        };
        var delay = function(ev, ob) {
          ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
          ob.hoverIntent_s = false;
          return cfg.out.apply(ob, [ev])
        };
        var handleHover = function(e) {
          var ev = $.extend({}, e);
          var ob = this;
          if (ob.hoverIntent_t) {
            ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t)
          }
          if (e.type === "mouseenter") {
            pX = ev.pageX;
            pY = ev.pageY;
            $(ob).on("mousemove.hoverIntent", track);
            if (!ob.hoverIntent_s) {
              ob.hoverIntent_t = setTimeout(function() {
                compare(ev, ob)
              }, cfg.interval)
            }
          } else {
            $(ob).off("mousemove.hoverIntent", track);
            if (ob.hoverIntent_s) {
              ob.hoverIntent_t = setTimeout(function() {
                delay(ev, ob)
              }, cfg.timeout)
            }
          }
        };
        return this.on({
          "mouseenter.hoverIntent": handleHover,
          "mouseleave.hoverIntent": handleHover
        }, cfg.selector)
      };

window.theme = window.theme || {};

theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $w: $(window),
    $body: $('body'),

    // Mobile Nav
    $mobileNavTrigger: $('#MobileNavTrigger'),
    $mobileNav: $('#MobileNav'),
    $mobileSublistTrigger: $('.mobile-nav__sublist-trigger'),

    // Equal height elements
    $productGridImages: $('.grid-link__image--product'),
    $featuredGridImages: $('.grid-link__image--collection'),

    // Product page
    // $productImage: $('#ProductPhotoImg'),
    $productImage: $('.product-image-item'),
    $productImageGallery: $('.gallery__item'),

    // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',

    // Add to cart - Ajax
    $cartCount: $('.cart-count'),
    $addToCartBtn: $('form[action^="/cart/add"] :submit'),

    //Navigation
    $hasDropdownItem: $('.site-nav--has-dropdown')
  }
};

timber.cacheVariables = function () {
  timber.vars = {
    isTouch: timber.cache.$html.hasClass('supports-touch')
  }
};

theme.init = function () {
  theme.cacheSelectors();
  theme.mobileNav();
  timber.cacheVariables();
  theme.equalHeights();
  theme.cartPage();
  theme.toggleMenu();

  

  
  theme.enableAjax(theme.cache.$addToCartBtn);
  
};

theme.mobileNav = function () {
  theme.cache.$mobileNavTrigger.on('click', function() {
    theme.cache.$mobileNav.slideToggle(220);
  });

  theme.cache.$mobileSublistTrigger.on('click', function(evt) {
    var $el = $(this);

    // Enable commented out if statement to allow direct clicking on trigger link
    // if (!$el.hasClass('is-active')) {
    evt.preventDefault();
    $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    // }
  });
};

theme.equalHeights = function () {
  theme.cache.$w.on('load', resizeElements());

  theme.cache.$w.on('resize',
                    afterResize(function() {
    resizeElements();
  }, 250, 'equal-heights')
                   );

  function resizeElements() {
    theme.cache.$productGridImages.css('height', 'auto').equalHeights();
    theme.cache.$featuredGridImages.css('height', 'auto').equalHeights();
  }
};

theme.productImageGallery = function() {

  if (!theme.cache.$productImageGallery.length) {
    return;
  };

  theme.cache.$productImageGallery.magnificPopup({
    type: 'image',
    mainClass: 'mfp-fade',
    closeOnBgClick: true,
    closeBtnInside: false,
    closeOnContentClick: true,
    tClose: 'Close (Esc)',
    removalDelay: 500,
    callbacks: {
    open: function(){
    $('html').css('overflow-y','hidden');
  },
                                                 close: function(){
    $('html').css('overflow-y','');
  }
},
  gallery: {
    enabled: true,
      navigateByImgClick: false,
        arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
          tPrev: 'Previous (Left arrow key)',
          tNext: 'Next (Right arrow key)'
  }
});

theme.cache.$productImage.bind('click', function() {
  var imageId = $(this).attr('data-image-id');
  theme.cache.$productImageGallery.filter('[data-image-id="' + imageId + '"]').trigger('click');
});
};

theme.cartPage = function () {
  

  theme.cache.$body.on('click', theme.cache.cartNoteAdd, function () {
    $(this).addClass('is-hidden');
    $(theme.cache.cartNote).addClass('is-active');
    ajaxifyShopify.sizeDrawer();
  });
};

theme.backButton = function () {
  var referrerDomain = urlDomain(document.referrer);
  var shopDomain = urlDomain(document.url);

  if (shopDomain === referrerDomain) {
    history.back();
    return false;
  }

  function urlDomain(url) {
    var    a      = document.createElement('a');
    a.href = url;
    return a.hostname;
  }
};


theme.addToCartflip = function ($addToCartBtn) {

  // Get label of add to cart button
  var addToCartText = $addToCartBtn.attr('data-add-to-cart') || "Add to cart";

  // Make a copy of the add to cart button should we flip it
  $addToCartBtn
  .clone(true)
  .prop('disabled', false)
  .removeClass('disabled')
  .addClass('btn--unflipped')
  .find('span')
  .text(addToCartText)
  .end()
  .hide()
  .insertAfter($addToCartBtn);
  
   
  // Unflip button if another variant is selected
  $('.single-option-selector, [name="quantity"]').bind('click', function() {
    $(this).closest('form').find('.btn--flipped, ., .note').remove();
    $(this).closest('form').find('.btn--unflipped').removeClass('.btn--unflipped').show();
  });
};

var all_options_arr = [];
var all_item_id_arr = [];
var id_flag = false;


theme.enableAjax = function (form) {
  form.bind('click', function(e) {
    e.preventDefault();
    $('.note.errors').remove();
    var $addToCartBtn = $(this),
        $addToCartForm = $(this).closest('form'),
        $addToCartBtnText = $(this).find('span');
    if ($addToCartForm.length) {
      $addToCartBtn
      .attr('data-add-to-cart', $addToCartBtnText.text())
    //  .prop('disabled', true)
     // .addClass('disabled')
      .addClass('btn--loading');
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(lineItem) {

          //           var item_img = lineItem.image;
          //           var cur_currency = 'money_with_currency_format';
          //           var cookieCurrency = Currency.cookie.read();

          //           var item_price =  Currency.formatMoney(lineItem.price, theme.moneyFormat);
          //           var convertedPrice = Currency.convert(lineItem.price,shopCurrency,cookieCurrency);
          //           var itemPriceConverted = Currency.formatMoney(convertedPrice, Currency.moneyFormats[cookieCurrency][cur_currency]);


          //           var item_title = lineItem.product_title;
          //           var item_type = lineItem.product_type;
          //           var item_qty = lineItem.quantity;
          //           var item_url = lineItem.url;
          //           var item_vendor = lineItem.vendor;
          //           var variant_id = lineItem.variant_id;


          //  var cart_drawer = '<div class="cart-summary global-border-radius cart-summary-drawer">'+
          //   '<div>'+                
          //     '<a class="cart-summary__checkout" href="/cart">Cart</a>'+
          //      '<a class="added-notice__close feather-icon" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></a>'+
          //      '</div>'+              
          //   '<div class="cart-summary__product">'+
          //     '<div class="cart-summary__product-image">'+     
          //           '<img class="" src="'+item_img+'">'+    
          //     '</div>'+    
          //     '<div class="cart-summary__product__description">'+    
          //       '<div class="cart-summary__product-title"><a href="'+item_url+'" title="">'+item_title+'</a></div>'+    
          //       '<div class="cart-summary__price">'+    
          //         '<span class="theme-money money">'+itemPriceConverted+'</span>'+    
          //         '<span class="cart-summary__quantity"> x &nbsp;'+item_qty+'</span>'+                         
          //       '</div>'+    
          //       '<div class="cart-summary__product__variants"></div>'+ 
          //     '</div>'+ 
          //   '</div>'+             
          // '</div>';

          //           $(".header-columns").append(cart_drawer);

          //         var product_options = $(".product_options_container").data("options").split(" ");
          //           	product_options.pop();
          //         var product_options_length = product_options.length;
          //           if(product_options_length>0){
          //             for(i=0;i<product_options_length;i++){
          //               var options_content = '<div class="added-notice__variant">'+    
          //                   '<span class="added-notice__variant-label">'+product_options[i]+': </span>'+    
          //             '<span class="added-notice__variant-value">'+lineItem.variant_options[i]+'</span>'+    
          //             '</div>'  
          //              $(".cart-summary__product__variants").append(options_content); 
          //             }
          //           }       

          //           var checkout_row = '<div class="checkout">'+
          //           '<a href="https://bloomr.com/checkout" class="checkout_link_drawer">Checkout</a>'+    
          //            '<a href="javascript:void(0);" class="continue_shopping_drawer">Continue shopping</a>'+              
          //               '</div>';

          //           $(".cart-summary-drawer").append(checkout_row);
          //           $(".cart-summary-drawer").fadeIn(200);

          //           var drawer_timeout =  window.setTimeout(function(){
          //             $(".cart-summary-drawer").fadeOut(200).delay(200).remove();
          //           }, 6000);


          var all_id_items = $('body').find('#cart_item_options').data('items_id').trim().slice(0, -1).split(',');
          for(var q = 0; q < all_id_items.length; q++) {
            if(all_id_items[q] == lineItem.id) {
              id_flag = true;
            }
          }
          var addToCartText = $addToCartBtn.attr('data-add-to-cart') || "Add to cart" ;
          $addToCartBtn.removeClass('btn--loading');

          $addToCartBtn.find('span').html("Added to cart");
          $.getJSON('/cart.js', function(cart) {
            theme.cache.$cartCount.text(cart.item_count);
            $('.hidden-count').removeClass('hidden-count');

            if(cart.item_count>0){
              $(".cart-summary__product-wrapper").empty();

              var current_array = $('body').find('#cart_item_options').html().trim().slice(0, -1).split(',');
              var product_options = $(".product_options_container").data("options").split(" ");              
              product_options.pop();
              if(id_flag == false ) {
                all_options_arr.push(product_options);
              }

              for (var x = 0; x < current_array.length; x++){
                var item_arr = current_array[x];            
                item_arr = item_arr.split(' '); 
                item_arr.pop();
                all_options_arr.push(item_arr);
              }     

              for(var j=0;j<cart.items.length;j++){

                var lineItem = cart.items[j];   
                var item_img = lineItem.image;
                var cur_currency = 'money_with_currency_format';
                
                
                var cookieCurrency = Currency.cookie.read();               
                var item_price =  Currency.formatMoney(lineItem.price, theme.moneyFormat);
                var convertedPrice = Currency.convert(lineItem.price,shopCurrency,cookieCurrency);
                var itemPriceConverted = Currency.formatMoney(convertedPrice, Currency.moneyFormats[cookieCurrency][cur_currency]);
                var totalConvertedPrice = Currency.convert(cart.total_price,shopCurrency,cookieCurrency);
                var totalPriceConverted = Currency.formatMoney(totalConvertedPrice, Currency.moneyFormats[cookieCurrency][cur_currency]);
                

                var item_title = lineItem.product_title;
                var item_type = lineItem.product_type;
                var item_qty = lineItem.quantity;
                var item_url = lineItem.url;
                var item_vendor = lineItem.vendor;
                var variant_id = lineItem.variant_id;



                var cart_drawer = '<div class="cart-summary__product">'+
                    '<div class="cart-summary__product-image">'+     
                    '<img class="" src="'+item_img+'">'+    
                    '</div>'+    
                    '<div class="cart-summary__product__description">'+    
                    '<div class="cart-summary__product-title"><a href="'+item_url+'" title="">'+item_title+'</a></div>'+    
                    '<div class="cart-summary__price">'+    
                    '<span class="theme-money money">'+itemPriceConverted+'</span>'+    
                    '<span class="cart-summary__quantity"> x &nbsp; <input type="number" name="quantity"  min="0" value="' + item_qty +'" class="cart-summary__quantity_input"  data-id="' + variant_id + '"/></span>'+                         
                    '</div>'+    
                    '<div class="cart-summary__product__variants"></div>'+ 
                    '</div>'+              
                    '</div>';

                $(".cart-summary__product-wrapper").append(cart_drawer);
                var product_options_length = all_options_arr[j].length;

                if(product_options_length>0){
                  for(i=0;i<product_options_length;i++){
                    var options_content = '<div class="added-notice__variant">'+    
                        '<span class="added-notice__variant-label">'+all_options_arr[j][i]+': </span>'+    
                        '<span class="added-notice__variant-value">'+lineItem.variant_options[i]+'</span>'+   
                        '</div>'  
                    if (lineItem.variant_options[i] != 'Default Title') {                      
                      $(".cart-summary__product-wrapper .cart-summary__product:nth-child("+(j+1)+")  .cart-summary__product__variants").append(options_content); 
                    } 
                  }
                }              

              }  
               $(".hidden_total_value").html("<span class='money hidden_total_value'>"+totalPriceConverted+"</span>").find(".money").unwrap();
              $(".hidden_cart_drawer").removeClass("hidden_cart_drawer");
              $(".cart-summary-modal").css({top: "15px",right: "15px"});
              $(".cart-summary-modal").fadeIn(200);
              var drawer_timeout =  window.setTimeout(function(){
                $(".cart-summary-modal").fadeOut(200);
                $(".cart-summary-modal").removeAttr("style");
              }, 5000);

              $(".cart-summary-modal").on( "mouseenter", function(){
                clearTimeout(drawer_timeout);  
                if( $(window).width() <=768) {

                  $('.cart-summary-modal .close_cart_modal').show();
                }
              });
              $(".cart-summary-modal").on( "mouseleave", function(){
                $(".cart-summary-modal").removeAttr("style");
              });
            }
          });
          setTimeout(function() {
            $addToCartBtn.find('span').html(addToCartText);
          }, 3000);
//           theme.addToCartflip($addToCartBtn);
        },
        error: function(XMLHttpRequest, textStatus) {
          var data = eval('(' + XMLHttpRequest.responseText + ')');
          var response = data.description;
          var status = XMLHttpRequest.status;
          $addToCartBtn.removeClass('btn--loading');
          if (status === 422 && $('#productSelect option').length === 1) {
            $addToCartBtnText.text("Sold Out");
                                   }
                                   else {
                                   $addToCartBtn.prop('disabled', false).removeClass('disabled');
            $addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
          }
          $addToCartBtn.after('<p class="note errors">' + response + '</p>');
        }
      });
    }
  });
};

theme.toggleMenu = function () {
  var $doc = $(document);
  var showDropdownClass = 'show-dropdown';

  // Open sub navs on small screens
  theme.cache.$hasDropdownItem.on('click', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(showDropdownClass) && timber.vars.isTouch) {
      evt.preventDefault();
      $el.addClass(showDropdownClass);
      $doc.on('click', handleClickOutsideDropdown);
    }

    function handleClickOutsideDropdown (evt) {
      var $target = $(evt.target);

      if (!$target.is($el) && !$.contains($el[0], $target[0])) {
        $el.removeClass(showDropdownClass);
        $doc.off('click', handleClickOutsideDropdown)
      }
    }
  })
};

// Initialize theme's JS on docready
$(theme.init)
$('.product_accardeon').on('click', '.accardeon_title', function(e) {
  e.preventDefault();
  $(this).toggleClass('active');
  $(this).next().slideToggle().toggleClass('show');
});
$('body').on('click', '.page-custom-accordion-title', function(e) {
  e.preventDefault();
  $(this).toggleClass('active');
  $(this).next().slideToggle(300);
});
$(document).ready(function () {
  $('.cart-summary-modal').on('change', '.cart-summary__quantity_input', function() {
    var variant_id = $(this).data('id');
    var quantity = $(this).val();
    var self = $(this);
    self.addClass('no_active');
    var data_parametrs = {
      quantity: quantity,
      id: variant_id
    };


    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      async:false,
      type: 'post',
      data: data_parametrs,
      success: function(cart) {
        if(cart.item_count < 1){
          $(".cart-summary__product-wrapper").empty();
          $('.cart-icon .count').html('0');
          $('.cart-icon .count').addClass('hidden');
        } else {
          $('.cart-icon .count').removeClass('hidden');
          $('.cart-icon .count').html(cart.item_count);
        }


        self.removeClass('no_active');
        if(quantity == 0) {
          self.closest('.cart-summary__product').hide('500', function(){
            $(this).remove();
          });
        }

      }

    });

  });
  $('a.more_info_btn').magnificPopup({
    type: 'ajax',
    closeOnContentClick:false,
    mainClass:'quick_view_tag_product',
    callbacks : {     
       elementParse: function(item) {
              item.src = item.src + "?view=quickview";
      },
      ajaxContentAdded : function() {
        $('.quick_view_tag_product  .product_accardeon').on('click', '.accardeon_title', function(e) {
          e.preventDefault();
          $(this).toggleClass('active');
          $(this).next().slideToggle().toggleClass('show');
        });
        theme.enableAjax($('.quick_view_tag_product form[action^="/cart/add"] :submit'));

        var productImageCount = $('.quick_view_tag_product #product-image-slider').find('.product-image-item').length;
        var productImageLoop = false;
        if( productImageCount > 1 ){
          productImageLoop = true;
        }

        var productImageSlider = $('.quick_view_tag_product #product-image-slider');
        if(productImageLoop) {
          productImageSlider.owlCarousel({
            nav:false,
            items:1,
            loop: productImageLoop,
            autoplay: false,
            autoplayTimeout: 4000,
            autoplaySpeed: 750,
            dots: true,
            navText: ['<img src="//www.bloomr.com/cdn/shop/t/99/assets/product-slider-arrow-left.png?v=28406240592392335921651590555"/>','<img src="//www.bloomr.com/cdn/shop/t/99/assets/product-slider-arrow-right.png?v=87071194193309311061651590556"/>'],
                      })
                      }

                      jQuery(document).on('click','.product-thumbs-list li a', function( event ){4
                      event.preventDefault();
                      var reqIndex = jQuery(this).parent('li').index();
                      productImageSlider.trigger('to.owl.carousel',[reqIndex]);
          });



          // BX SLIDERS
          jQuery('.quick_view_tag_product .product-thumbs-list').each( function(){
            if($(this).find('.product-thumbs-item').length >=4 ) {
              jQuery(this).bxSlider({
                mode: 'horizontal',
                slideWidth: '150',
                maxSlides: 4,
                moveSlides :1,
                pager: false,
                responsize: false,
                infiniteLoop: false,
                hideControlOnEnd: true,
                prevText: '<img src="//www.bloomr.com/cdn/shop/t/99/assets/product-slider-arrow-left.png?v=28406240592392335921651590555"/>',
                nextText: '<img src="//www.bloomr.com/cdn/shop/t/99/assets/product-slider-arrow-right.png?v=87071194193309311061651590556"/>'
              });
            }

          });




        }
      }
    });
    $('.cart-summary-modal').on('click', '.close_cart_modal', function() {
    $(this).closest('.cart-summary-modal').hide();
    $(this).hide();
  });
  
    $('ul.header-nav > li.has-dropdown').hoverIntent(function() {
    $(this).addClass('hover');
    $(this).find(".sub-menu-wrapper").addClass("show_block");
  }, function() {
    $(this).removeClass('hover');
    $(this).find(".sub-menu-wrapper").removeClass("show_block");
  });
  
  KlaviyoSubscribe.attachToForms('.footer-newsletter #mc-embedded-subscribe-form', {
    success: function ($form) {
      var email_input = $form.find('[name="email"]');
      var confirmation_message = "We'll stay in touch!";
      email_input.val(confirmation_message);
      email_input.attr('placeholder', confirmation_message);
      email_input.attr('disabled', true);
      $form.find('.btn').attr('disabled', true);
    }
  });  
  $("body").on("klaviyo.subscribe.error", '.footer-newsletter #mc-embedded-subscribe-form' , function(){
    $(this).off().submit();
  });
   $('body').on('click', '.related_collection_grid .btn', function(e) {
    e.preventDefault();

    var btn = $(this);
    var variant_id = +(btn.attr('data-value'));
    btn.prop('disabled', true).addClass('disabled');
   

    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=' + 1 + '&id=' + variant_id,
      dataType: 'json',
      success: function(line_item) { 
        location.reload();
      },
      error: function(XMLHttpRequest, textStatus) {
        Shopify.onError(XMLHttpRequest, textStatus);
        btn.removeAttr('disabled').removeClass('disabled');
      }
    };
    jQuery.ajax(params);

  });
  
  
    $("body").on("click.checkout", ".continue_shopping_drawer, button.checkout", function(e){
    e.preventDefault();
    if(e.target.nodeName == "BUTTON"){
      var submit_form = true;
      var button = $(this);
    }else{
        var submit_form = false;
    }
    if($(".currency-picker").val() == "SAR"){  
    var SAR_value = $(".hidden_total_value").html();  
      var SAR_message = " "+ SAR_value;  
    }else{
      var SAR_message = "";  
    }
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: {attributes: {'Total in SAR currency': SAR_message}},
        dataType: 'json',
        success: function() { 
          if(submit_form){
           $("body").off("click.checkout");
           button.click();
          }else{
            if(Shopify.routes.root != "/"){
               window.location.href = Shopify.routes.root + "/checkout";      
            }else{
              window.location.href = "/checkout";    
            }
          }
        },
        error: function(XMLHttpRequest, textStatus) {
          Shopify.onError(XMLHttpRequest, textStatus);
          btn.removeAttr('disabled').removeClass('disabled');
        }
      };
      jQuery.ajax(params);
      
  
  });
   

  
});